import { useTranslation } from "react-i18next";
import {
  HOME_LAYOUT_SURFACE,
  type HomeWidgetId,
  type WidgetLayout,
} from "@heraion/shared";

import type { UiTheme } from "../theme";
import { HOME_WIDGET_COLUMN, homeWidgetLabel } from "./homeWidgetCatalog";
import { WidgetConfigSheet } from "./WidgetConfigSheet";

const columnOf = (id: HomeWidgetId) => HOME_WIDGET_COLUMN[id];

// HR-11: the page that configures Home, the widget config sheet bound to the
// Home surface. No collapsed state here: that one is Progress's (PG-57).
export function HomeConfigSheet({
  theme,
  visible,
  onClose,
  layout,
  onMove,
  onHide,
  onShow,
  onReset,
  isDefault,
  saveFailed,
  topInset,
  bottomInset,
}: {
  theme: UiTheme;
  visible: boolean;
  onClose: () => void;
  layout: WidgetLayout<HomeWidgetId>;
  /** Move `id` to `toIndex` of `layout.order`. */
  onMove: (id: HomeWidgetId, toIndex: number) => void;
  onHide: (id: HomeWidgetId) => void;
  onShow: (id: HomeWidgetId) => void;
  onReset: () => void;
  isDefault: boolean;
  saveFailed: boolean;
  topInset?: number;
  bottomInset?: number;
}) {
  const { t } = useTranslation();
  return (
    <WidgetConfigSheet
      theme={theme}
      visible={visible}
      onClose={onClose}
      title={t("mobile.home.config.title", { defaultValue: "Customize Home" })}
      saveErrorText={t("mobile.home.config.saveError", {
        defaultValue: "Couldn't save your Home. Please try again.",
      })}
      surface={HOME_LAYOUT_SURFACE}
      labelOf={(id) => homeWidgetLabel(t, id)}
      columnOf={columnOf}
      layout={layout}
      onMove={onMove}
      onHide={onHide}
      onShow={onShow}
      onReset={onReset}
      isDefault={isDefault}
      saveFailed={saveFailed}
      topInset={topInset}
      bottomInset={bottomInset}
    />
  );
}
